/* eslint-disable no-param-reassign */
/* eslint-disable prettier/prettier */

const buttonSpace = () => {
  // Find all buttons with the `.wmnds-btn` class
  const buttons = document.querySelectorAll('.wmnds-btn');
  buttons.forEach((btn) => {
    // Use previousElementSibling to find the element immediately before the button
    const prev = btn.previousElementSibling;

    // Determine the actual <p> element that should be adjusted.
    // Handle cases where the <p> is the previous sibling, or where the previous sibling
    // is a <div> that contains the <p> (e.g. <div><p>...</p></div><button>...)
    let targetP = null;

    if (prev && prev.tagName) {
      const name = prev.tagName.toLowerCase();
      if (name === 'p') {
        targetP = prev;
      } else if (name === 'div') {
        const lastChild = prev.lastElementChild;
        if (lastChild && lastChild.tagName && lastChild.tagName.toLowerCase() === 'p') {
          targetP = lastChild;
        } else {
          // fallback: find any <p> inside the div
          const anyP = prev.querySelector('p');
          if (anyP) targetP = anyP;
        }
      }
    }

    if (targetP) {
      // Only apply if the paragraph is within a <div> ancestor
      if (targetP.closest && targetP.closest('div')) {
        targetP.style.marginBottom = '0px';
      }
    }
  });

  // Additional rule: if a `.ds-btn` is followed by a <div> that contains a heading (h1-h6),
  // add a bottom margin of 20px to the `.ds-btn` so there's spacing before the heading.
  const dsButtons = document.querySelectorAll('.wmnds-btn');
  dsButtons.forEach((btn) => {
    console.log('Checking .ds-btn:', btn);
    const next = btn.nextElementSibling;
    if (!next) return;

    // only consider when the immediate next sibling is a div
    if (next.tagName && next.tagName.toLowerCase() === 'div') {
      // look for any heading inside the div
      const heading = next.querySelector('h1, h2, h3, h4, h5, h6');
      if (heading) {
        btn.style.marginBottom = '3rem'; // add spacing before the heading
      }
    }
  });
};

export default buttonSpace;
